import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../Context/UserContext';
import { PERMISSIONS } from '../Utils/permissions';

const AdminDashboardRedirect = () => {
  const { permissions, loading } = useUser();

  if (loading) {
    return <div className="loading-screen"><div className="spinner"></div></div>;
  }

  if (permissions?.[PERMISSIONS.PRODUCTS_MANAGE]) {
    return <Navigate to="/admin/products" replace />;
  }

  if (permissions?.[PERMISSIONS.ORDERS_VIEW]) {
    return <Navigate to="/admin/orders" replace />;
  }

  if (permissions?.[PERMISSIONS.DELIVERY_VIEW]) {
    return <Navigate to="/admin/delivery" replace />;
  }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ margin: 0, marginBottom: 8 }}>Admin access granted</h2>
      <p style={{ margin: 0 }}>No admin sections are assigned to your account.</p>
    </div>
  );
};

export default AdminDashboardRedirect;
